import process from "process";
import { Buffer } from "buffer";

// Use the polyfills from the vite.config.ts
window.process = process;
window.Buffer = Buffer;

(window as any).global = window;
